const Version = {
    version: '0.7.5',
    branch: 'release/0.7.5',
    commit: '263f279'
};

export { Version };
//# sourceMappingURL=version.js.map
